module.exports = __webpack_public_path__ + "img/transcribing.bb7cf95b.svg";